import { render, staticRenderFns } from "./ricerca.vue?vue&type=template&id=e597f540&scoped=true&"
import script from "./ricerca.vue?vue&type=script&lang=js&"
export * from "./ricerca.vue?vue&type=script&lang=js&"
import style0 from "./ricerca.vue?vue&type=style&index=0&id=e597f540&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e597f540",
  null
  
)

export default component.exports